// extracted by mini-css-extract-plugin
export default {"container":"TitleScreen_container__OKMbH"};